module.exports = __webpack_public_path__ + "img/primary_2x1.3db521b5.svg";